export const GET_TRANSMISSION_VALIDATOR_REQUEST = "GET_TRANSMISSION_VALIDATOR_REQUEST";
export const GET_TRANSMISSION_VALIDATOR_SUCCESS = "GET_TRANSMISSION_VALIDATOR_SUCCESS";
export const GET_TRANSMISSION_VALIDATOR_FAILURE = "GET_TRANSMISSION_VALIDATOR_FAILURE";

export const GET_TRANSMISSION_HISTORY_LOGS_REQUEST = "GET_TRANSMISSION_HISTORY_LOGS_REQUEST";
export const GET_TRANSMISSION_HISTORY_LOGS_SUCCESS = "GET_TRANSMISSION_HISTORY_LOGS_SUCCESS";
export const GET_TRANSMISSION_HISTORY_LOGS_FAILURE = "GET_TRANSMISSION_HISTORY_LOGS_FAILURE";

export const SET_STATE_TRANSMISSION_VALIDATOR = "SET_TRANSMISSION_VALIDATOR";

export const CLOSE_WEBSOCKET_TRANSMISSION_VALIDATOR = "CLOSE_WEBSOCKET_TRANSMISSION_VALIDATOR";

export const getTransmissionValidatorRequest = (filters = {}) => ({
    type: GET_TRANSMISSION_VALIDATOR_REQUEST,
    payload: {
        filters
    }
});

export const getTransmissionValidatorSuccess = transmissions => ({
    type: GET_TRANSMISSION_VALIDATOR_SUCCESS,
    payload: {
        transmissions
    }
});

export const getTransmissionValidatorFailure = err => ({
    type: GET_TRANSMISSION_VALIDATOR_FAILURE,
    error: err
});

export const getTransmissionHistroyLogsRequest = (imei = '', filters = {}) => ({
    type: GET_TRANSMISSION_HISTORY_LOGS_REQUEST,
    payload: {
        imei,
        filters
    }
});

export const getTransmissionHistroyLogsSuccess = (historyLogs, total) => ({
    type: GET_TRANSMISSION_HISTORY_LOGS_SUCCESS,
    payload: {
        historyLogs,
        total
    }
});

export const getTransmissionHistroyLogsFailure = err => ({
    type: GET_TRANSMISSION_HISTORY_LOGS_FAILURE,
    error: err
});

export const closeWebsocketTransmissionValidator = () => ({
    type: CLOSE_WEBSOCKET_TRANSMISSION_VALIDATOR
});

export const setStateTransmissionValidator = payload => ({
    type: SET_STATE_TRANSMISSION_VALIDATOR,
    payload: { ...payload }
});
